import  { useEffect, useState } from 'react';
import './App.css';
import './fontawesome-stars.css';
import './fontawesome-stars-o.css';
import Routes from 'routes';
import Loader from './components/Loader';
import ThemeCustomization from 'themes';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { FormsProvider } from 'contexts/FormsContext';
import Notistack from 'third-party/Notistack';
// import Customization from 'components/Customization';
import Snackbar from 'components/@extended/Snackbar';
import Locales from 'components/Locales';
import { dispatch } from 'store';
import { fetchDashboard } from 'store/reducers/menu';

// import { dispatch } from 'store';

function App() {
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    dispatch(fetchDashboard()).then(() => {
    });
    
    setLoading(true);
  }, []);
  if (!loading) return <Loader />;
  return (
    <ThemeCustomization>
      <RTLLayout>
      <Locales>
        <ScrollTop>
          <AuthProvider>
          <FormsProvider>
            <>
              <Notistack>
                <Routes />
                {/* <Customization /> */}
                <Snackbar />
              </Notistack>
            </>
            </FormsProvider>
          </AuthProvider>
        </ScrollTop>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
}

export default App;
